export default "__VITE_ASSET__Bx5DbKR5__"